module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av94-8f6efef85c55eaeef6f919b9e6430e7a.jpg";